import cookieUtil from './cookie'

const ua = navigator.userAgent;
export const isWindowsPhone = /(?:Windows Phone)/.test(ua);
export const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
export const isTdAndroid = ua.indexOf('android-tongdao-app') > -1;
export const isTdIos = ua.indexOf('ios-tongdao-app') > -1;
export const isTdRN = ua.indexOf('rn-tongdao-app') > -1;
export const isAndroid = isTdAndroid || ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
export const isIos = isTdIos || !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isWx = /MicroMessenger/ig.test(ua);
export const isBaidu = /(Baidu|baiduboxapp)/.test(ua);
export const isUc = /UCBrowser/.test(ua);
export const isDingding = /DingTalk/.test(ua);
export const isUcOrDingding = isUc || isDingding;
export const isTd = isTdAndroid || isTdIos || isTdRN;
export const isH5 = isAndroid || isIos || isSymbian;
export const isPC = !isH5;
// 判断app版本号
export const appVc = cookieUtil.get('app_vc');
